import tambor from "../assets/tambor2.png";






export default { tambor }